import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './auth';
import { ErrorBoundary } from './ErrorBoundary';
import { PORTAL_RELEASE } from './release';
import './styles.css';

document.documentElement.dataset.packproofSurface = PORTAL_RELEASE.surface;
document.documentElement.dataset.packproofVersion = PORTAL_RELEASE.productVersion;
document.documentElement.dataset.packproofSha = PORTAL_RELEASE.gitSha;

const root = document.getElementById('root');
if (!root) throw new Error('PackProof portal root element is missing.');

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>,
);
